import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { useQuery, UseQueryResult } from 'react-query'
import { DocumentType } from '@dc-shared-web/hooks/api/office/types'
import { fetchOfficeDocumentTypes } from '@dc-shared-web/hooks/api/office/fetchOfficeDocumentTypes'

type UseGetOfficeDocumentTypes = (params?: {
  enabled?: boolean
}) => UseQueryResult<DocumentType[], Error>

export const useGetOfficeDocumentTypes: UseGetOfficeDocumentTypes = ({
  enabled = true,
} = {}) => {
  const apiClient = useSvcCrunchesContext()

  return useQuery<DocumentType[], Error>(
    ['office', 'document-types'],
    async () => {
      const data = await fetchOfficeDocumentTypes(apiClient)

      return data
    },
    {
      enabled,
    }
  )
}
